import React, { Component } from 'react';
import './Signup.css';
import logoblue from '../../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import { LinkAPI } from '../../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios'
import Footer from '../Components/Footer/Footer'

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            password: "",
            confirmpassword: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            confirmpasswordError: "",
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
    }
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    componentDidMount() {
        window.scrollTo(0, 0)
      }
    validate = () => {
        let nameError = "";
        let emailError = "";
        let passwordError = "";
        let confirmpasswordError="";
        if (this.state.name.length < 2||!isNaN(this.state.name)) {
            nameError = "ادخل الاسم صحيح";
        }
        
        
        if (this.state.password.length < 8) {
            passwordError = "يجب ان يكون كلمة السر اكبر من 8 حروف او ارقام";
        }
        
        if (this.state.confirmpassword.length < 8 || this.state.password !== this.state.confirmpassword) {
            confirmpasswordError = "كلمة السر غير مطابقه";
        }

        if (!this.state.email.includes("@")) {
            emailError = "بريد الكتروني غير صحبح";
        }

        if (nameError||emailError || passwordError||confirmpasswordError) {
            this.setState({ nameError, emailError, passwordError, confirmpasswordError});
            return false;
        }

        return true;
    };

    handleSubmit = event => {
        event.preventDefault();
        const {name,email,password}= this.state
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/businessowner/signup`,{  name:name, email:email, password:password},{
                headers:{ lang:"ar"}
               
              }).then(res =>{
                localStorage.setItem("userTokentConfirmData",res.data.businessOwner.token)
                window.location.replace("/AR/ConfirmData");
             
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/AR/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        nameError: "",
                        emailError: "",
                        passwordError: "",
                        confirmpasswordError: "",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };
    render() {
        document.title ="kayn | سجل الان"; 
        document.getElementsByTagName("META")[1].content="كاين | سجل الان";
        document.documentElement.lang = 'ar';
        return (
            <div className="AppAR signup">
                <Navbar />
                <div className='container'>
                    <div className="Sign  row">
                        
                        <div className="col-md-6 form float-md-left  ">
                            <div className="contantform text-center p-4 ">
                                <h3 className="fontsize1 my-4">سجل الان</h3>
                                <p className="fontsize6 my-4">سجيل الان لمتابعة الوصول إلى الصفحات</p>
                                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                                    <div className="form-group my-4">
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="الاسم" name="name" value={this.state.name} onChange={this.handleChange} required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.nameError}
                                        </div>
                                    </div>
                                    <div className="form-group my-4">
                                        <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="البريد الالكتروني" name="email" value={this.state.email} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" ,}}>
                                            {this.state.emailError}
                                        </div>
                                    </div>
                                    
                                    <div className="form-group my-4">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder="الرقم السري" name="password" value={this.state.password} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.passwordError}
                                        </div>
                                    </div>
                                    <div className="form-group my-4">
                                        <input type="password" id="confirm_password" className={"form-control badge-pill p-3 " + (this.state.confirmpasswordError ? 'is-invalid' : '')} placeholder="التحقق من الرقم السري" name="confirmpassword" value={this.state.confirmpassword} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.confirmpasswordError}
                                        </div>
                                    </div>
                                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessageText}
                      </div> : '')}
                                    <button type="submit"className="btn badge-pill btn-block shadow p-2 mb-2"  >تسجيل</button>
                                </form>
                            </div>
                        </div>
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/AR/"><img className="logo" src={logoblue} alt="kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">طلبك الخاصة بك ... طريقك</p>
                        </div>
                    </div>
                </div>
                <Footer/>

                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger" /> : '')}

            </div>
        )
    }
}
export default Signup;